export function next_quarter(q, year, num)
{
    if(num > 0)
    {
        for(let i = num; i > 0; --i)
        {
            if(q === 4)
            {
                ++year;
                q = 1;
            }
            else
            {
                ++q;
            }
        }
    }
    else if(num < 0)
    {
        for(let i = num; i < 0; ++i)
        {
            if(q === 1)
            {
                --year;
                q = 4;
            }
            else
            {
                --q;
            }
        }
    }

    return { q, year };
}